
	import { Component, Vue, Watch } from 'vue-property-decorator';
	import { Observer } from 'mobx-vue';
	import { reaction, IReactionDisposer } from 'mobx';
	import LandmarkGuide from '@/components/LandmarkGuide.vue';
	import store from '@/store/mainStore';

	@Observer
	@Component({ components: { LandmarkGuide } })
	export default class LandmarkSelectionView extends Vue {
		private disabled: boolean = false;
		private resetting: boolean = false;

		async activated() {
			// for redirect from occipital app to /landmarks
			if (!store.biometric.bothScansExist && !store.biometric.leftScanExists && !store.biometric.rightScanExists) {
				await store.biometric.getLatestScans();
			}
			this.disabled = false;
			await this.$state.leroy.SetScene('LandmarkSelection');
			this.$state.leroy.modalVisible = true;
		}

		public async next() {
			this.disabled = true;
			await this.$router.push('results');
		}

		public async prev() {
			await this.$router.push('threed');
		}

		public async clearLandmarks() {
			this.resetting = true;
			this.$state.leroy.onResetLandmarks();
			this.resetting = false;
		}
	}
